import { useEffect, useState } from "react";
import {
    listarCuentas,
    crearCuenta,
    actualizarCuenta,
    inactivarCuenta,
    listarMovimientosCuenta,
    registrarTransferencia, activarCuenta,
} from "../api/cuentaApi";

export default function useCuentas() {
    const [cuentas, setCuentas] = useState([]);
    const [loading, setLoading] = useState(false);
    const [cuentaSeleccionada, setCuentaSeleccionada] = useState(null);
    const [movimientosCuenta, setMovimientosCuenta] = useState([]);

    const cargarCuentas = async () => {
        setLoading(true);
        try {
            const data = await listarCuentas();
            setCuentas(Array.isArray(data) ? data : []);
        } catch (e) {
            console.error(e);
            setCuentas([]);
        } finally {
            setLoading(false);
        }
    };

    const activar = async (idCuenta) => {
        await activarCuenta(idCuenta);
        await cargarCuentas();
    };

    const guardarCuenta = async (payload, id) => {
        if (id) {
            await actualizarCuenta(id, payload);
        } else {
            await crearCuenta(payload);
        }
        await cargarCuentas();
    };

    const inactivar = async (id) => {
        await inactivarCuenta(id);
        await cargarCuentas();
    };

    const verDetalleCuenta = async (cuenta) => {
        setCuentaSeleccionada(cuenta);
        try {
            const data = await listarMovimientosCuenta(cuenta.idCuenta);
            setMovimientosCuenta(Array.isArray(data) ? data : []);
        } catch (e) {
            console.error(e);
            setMovimientosCuenta([]);
        }
    };

    const transferir = async (payload) => {
        await registrarTransferencia(payload);
        await cargarCuentas();
        if (cuentaSeleccionada?.idCuenta) {
            await verDetalleCuenta(cuentaSeleccionada);
        }
    };

    useEffect(() => {
        cargarCuentas();
    }, []);

    return {
        cuentas,
        loading,
        cuentaSeleccionada,
        movimientosCuenta,
        setCuentaSeleccionada,
        cargarCuentas,
        guardarCuenta,
        inactivar,
        activar,
        verDetalleCuenta,
        transferir,
    };
}